import { IconArrow, Button } from 'braid-design-system';
import type React from 'react';

type BackButtonProp = {
  onClick: () => void;
  children: React.ReactNode;
};

export const BackButton = ({ onClick, children }: BackButtonProp) => (
  <Button
    icon={<IconArrow direction="left" />}
    variant="soft"
    onClick={onClick}
    data={{ testid: 'page-level-back-button' }}
  >
    {children}
  </Button>
);
